module.exports = __webpack_public_path__ + "media/src/images/logos/partners/china-2868ccffb23d17fe4b6666d21299b444.svg";